import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
  onClick,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALLEST, SpacingName.SMALLER])}
  border: 1px solid ${theme.palettes.neutrals.light};
  background-color: ${theme.palettes.neutrals.lightest};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${onClick && `
    cursor: pointer;
  `}

  > *:first-child, a {
    color: ${theme.palettes.neutrals.darkest};
    text-decoration: none;
    margin-right: 1rem;
  }

  > *:last-child {
    flex-shrink: 0;
  }

  &:hover {
    box-shadow: rgba(51, 51, 51, 0.2) 0 0 4px 0px;
  }
`;

export const location: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  align-items: center;
  color: ${theme.palettes.neutrals.medium};

  > *:last-child {
    flex-shrink: 0;
  }
`;
